import { useLocation } from 'react-router-dom'
import support from '../../assets/support.svg'
import styles from './ButtonSupport.module.scss'

export default function ButtonsSupport() {
	const location = useLocation()

	if (location.pathname.startsWith('/account')) {
		return null
	}

	return (
		<div className={styles.support}>
			<span className={styles.tooltip}>
				<button
					onClick={() =>
						window.open('https://t.me/SairusSupport_bot', '_blank')
					}
					className={styles.btn_support}
				>
					<img
						className={styles.img_support}
						width='50px'
						height='50px'
						src={support}
						alt='Support'
					/>
				</button>
				<span className={styles.tooltip_text}>Support</span>
			</span>
		</div>
	)
}
